export default __webpack_public_path__ + "static/media/247.57ae8efa.jpg";